<template>
  <el-menu-item-group v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-menu-item-group>
</template>
<script>
export default {
  name: "aia-menu-item-group"
};
</script>